module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": "New RoundTable",
      "size": "relative_sm",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.handleCloseDialog()
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col pb-12 pt-1 items-center px-6 flex-grow h-full"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2.5 mb-6"
  }, [_c('div', {
    staticClass: "flex items-center border border-solid border-gray-200 rounded-full relative px-1 py-1 h-10"
  }, [_c('button', {
    staticClass: "flex items-center space-x-2 rounded-full h-full px-4 font-manrope",
    class: {
      'bg-blue text-white': _vm.roundtableType === 'written'
    },
    on: {
      "click": function($event) {
        return _vm.handleChangeRoundTableType('written')
      }
    }
  }, [_c('img', {
    staticClass: "w-3.5 h-3.5",
    attrs: {
      "src": _vm.roundtableType === 'written' ? '/static/roundtable_icons/written_icon.svg' : '/static/roundtable_icons/written_icon_black.svg'
    }
  }), _vm._v(" "), _c('span', [_vm._v("Written")])]), _vm._v(" "), _c('button', {
    staticClass: "flex items-center space-x-2 rounded-full h-full px-4 font-manrope",
    class: {
      'bg-green-light text-white': _vm.roundtableType === 'verbal'
    },
    on: {
      "click": function($event) {
        return _vm.handleChangeRoundTableType('verbal')
      }
    }
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": _vm.roundtableType === 'verbal' ? '/static/roundtable_icons/verbal_icon.svg' : '/static/roundtable_icons/verbal_icon_black.svg'
    }
  }), _vm._v(" "), _c('span', [_vm._v("Verbal")])])])]), _vm._v(" "), _c('div', {
    class: ['flex flex-col space-y-2.5 rounded-xl pl-1.5 pr-1 pt-1.5 pb-2 mb-5 w-full bg-gray-100 max-w-2xl relative', _vm.roundtableInputType === 'youtube' ? 'ring-2 ring-offset-2 ring-primary' : 'focus-within:ring-2 ring-offset-2 ring-primary']
  }, [_c('div', {
    staticClass: "flex justify-between items-center relative w-full"
  }, [_c('div', {
    staticClass: "flex items-center w-full"
  }, [(_vm.roundtableInputType && _vm.roundtableInput) ? _c('div', {
    staticClass: "ml-2 mr-1"
  }, [(_vm.roundtableInputType !== '') ? _c('div', [(_vm.roundtableInputType === 'youtube') ? _c('i', {
    staticClass: "fa-brands fa-youtube text-red-600"
  }) : _vm._e(), _vm._v(" "), (_vm.roundtableInputType === 'article') ? _c('i', {
    staticClass: "fa-solid fa-link"
  }) : _vm._e(), _vm._v(" "), (_vm.roundtableInputType === 'topic') ? _c('i', {
    staticClass: "fa-solid fa-quote-left"
  }) : _vm._e(), _vm._v(" "), (_vm.roundtableInputType === 'pdf') ? _c('i', {
    staticClass: "fa-regular fa-file-lines"
  }) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.documentUpload && !_vm.isUploading) ? _c('div', {
    staticClass: "w-full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roundtableInput),
      expression: "roundtableInput"
    }],
    ref: "inputRef",
    staticClass: "border-none w-11/12 pl-2 py-1 bg-gray-100 disabled:opacity-50 font-manrope",
    attrs: {
      "disabled": _vm.isGeneratingPromt,
      "placeholder": "Enter a topic, paste any URL, or upload a PDF..."
    },
    domProps: {
      "value": (_vm.roundtableInput)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleOpenDraft()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.roundtableInput = $event.target.value
      }
    }
  })]) : (_vm.isUploading) ? _c('div', {
    staticClass: "flex items-center space-x-2 pl-2 py-1"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2 justify-center bg-gray-100"
  }, [_c('div', {
    staticClass: "loader-primary"
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-manrope text-xs text-gray-800"
  }, [_vm._v("Uploading...")])]) : _c('div', {
    staticClass: "flex items-center space-x-2",
    on: {
      "mouseover": function($event) {
        _vm.isMouseHoverUrl = true
      },
      "mouseleave": function($event) {
        _vm.isMouseHoverUrl = false
      }
    }
  }, [_c('div', {
    staticClass: "border-none w-11/12 pl-2 py-1 bg-gray-100 font-manrope"
  }, [_c('a', {
    staticClass: "underline text-blue-500 hover:text-blue-600",
    attrs: {
      "href": _vm.documentUpload.aws_url,
      "target": "_blank"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.documentUpload.name) + "\n              ")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMouseHoverUrl === true),
      expression: "isMouseHoverUrl === true"
    }],
    staticClass: "w-5 h-5 hover:bg-red-200 bg-red-100 text-red-500 rounded-full",
    staticStyle: {
      "font-size": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.handleRemoveFile()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "absolute flex items-center gap-x-2 right-0.5 top-1/2 transform -translate-y-1/2"
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "accept": ".pdf"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "flex items-center justify-center text-gray-800 w-7 h-7 hover:bg-gray-200 rounded-lg transition-all duration-100 cursor-pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleTriggerUploadPDF()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-paperclip"
  })]), _vm._v(" "), _c('button', {
    staticClass: "text-white w-7 h-7 rounded-lg bg-primary hover:bg-primary-dark flex justify-center items-center cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.handleOpenDraft()
      }
    }
  }, [(_vm.isGeneratingPromt === false) ? _c('i', {
    staticClass: "fa-solid fa-arrow-right-long"
  }) : _vm._e(), _vm._v(" "), (_vm.isGeneratingPromt === true) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])])]), _vm._v(" "), _c('ul', {
    staticClass: "flex items-center space-x-1 ml-0.5 text-xs font-manrope text-gray-800"
  }, _vm._l((_vm.gradeLevels), function(level, index) {
    return _c('li', {
      key: level,
      class: [
        'px-2 py-0.5 rounded-md bg-white cursor-pointer border border-solid hover:border-primary',
        _vm.gradeLevel === level ? 'border-primary' : 'border-white'
      ],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleSelectGradeLevel(level)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(level))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2 text-center"
  }, [_c('button', {
    staticClass: "flex items-center space-x-3 hover:bg-gray-50 border border-solid border-gray-200 rounded-full px-4 py-2 text-center font-manrope text-gray-700 hover:text-gray-900 font-light",
    on: {
      "click": function($event) {
        return _vm.handleOpenDraft()
      }
    }
  }, [_c('img', {
    staticClass: "w-3.5 h-3.5",
    attrs: {
      "src": "/static/logos/new_roundtable_icon.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Start from scratch")])]), _vm._v(" "), _c('button', {
    staticClass: "flex items-center space-x-3 hover:bg-gray-50 border border-solid border-gray-200 rounded-full px-4 py-2 text-center font-manrope text-gray-700 hover:text-gray-900 font-light",
    on: {
      "click": function($event) {
        return _vm.handleGoToUniverse()
      }
    }
  }, [_c('img', {
    staticClass: "w-3.5 h-3.5",
    attrs: {
      "src": "/static/roundtable_options_create/browse_universe.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Browse Universe")])]), _vm._v(" "), _c('button', {
    staticClass: "flex items-center space-x-2.5 hover:bg-gray-50 border border-solid border-gray-200 rounded-full px-4 py-2 text-center font-manrope text-gray-700 hover:text-gray-900 font-light",
    on: {
      "click": function($event) {
        return _vm.handleGoToPortfolio()
      }
    }
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/folder.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v("My Portfolio")])]), _vm._v(" "), (_vm.is_teacher && _vm.free_teacher_account) ? _c('button', {
    staticClass: "flex items-center space-x-2 hover:bg-gray-50 border border-solid border-gray-200 rounded-full px-4 py-2 text-center font-manrope text-gray-700 hover:text-gray-900 font-light",
    on: {
      "click": function($event) {
        return _vm.handleUpgradeAccount()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-rocket text-pinky"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getProfile.activity_passes))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-32d59b1a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/GenerateRoundTable/GenerateRoundTable.vue
// module id = 933
// module chunks = 61